import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE = "https://anderstongroup.co.uk";

export const breadcrumbJsonLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.to}`,
  })),
});

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 text-xs tracking-[0.18em] uppercase text-black/55">
    {items.map((it, i) => (
      <span key={it.to} className="inline-flex items-center gap-1.5">
        {i > 0 && <ChevronRight size={11} className="opacity-50" />}
        {i < items.length - 1 ? (
          <Link to={it.to} className="hover:text-black transition-colors">{it.name}</Link>
        ) : (
          <span className="text-black" aria-current="page">{it.name}</span>
        )}
      </span>
    ))}
  </nav>
);

export default Breadcrumbs;
